import { utils } from '@cofit/api';
import { FoodNoteItemCalorieOr3NutritionQuickAddKindAttr, FoodNoteItemCalorieQuickAddKindAttr } from 'src/constants/diet';
import { FoodNoteItemCalorieQuickAddKind } from 'src/types';
export var getDisplayUnit = function getDisplayUnit(item, t) {
  return (item === null || item === void 0 ? void 0 : item.display_factor) === 1 ? t('client_mgmt:food.normalServing') : item === null || item === void 0 ? void 0 : item.serving_unit;
};
export var getCalcWeightKey = function getCalcWeightKey(item) {
  return (item === null || item === void 0 ? void 0 : item.display_factor) === 1 ? 'ex_weight' : 'serving_weight';
};
export var getDisplayWeight = function getDisplayWeight(item) {
  return item === null || item === void 0 ? void 0 : item[getCalcWeightKey(item)];
};
export var calcWeightFromAmount = function calcWeightFromAmount(item, amount) {
  var _ref = (item === null || item === void 0 ? void 0 : item.item_details) || {},
      display_factor = _ref.display_factor,
      _ref$ex_weight = _ref.ex_weight,
      ex_weight = _ref$ex_weight === void 0 ? 0 : _ref$ex_weight,
      _ref$serving_weight = _ref.serving_weight,
      serving_weight = _ref$serving_weight === void 0 ? 0 : _ref$serving_weight;

  var weight = display_factor === 1 ? amount * ex_weight : amount * serving_weight;
  return utils.Util.round(weight);
};
export var calcAmountFromWeight = function calcAmountFromWeight(assetItem, weight) {
  var _ref2 = (assetItem === null || assetItem === void 0 ? void 0 : assetItem.item_details) || {},
      display_factor = _ref2.display_factor,
      ex_weight = _ref2.ex_weight,
      serving_weight = _ref2.serving_weight;

  var amount = display_factor === 1 ? weight / ex_weight : weight / serving_weight;
  return utils.Util.round(amount);
};
export var getFoodNoteItemCalorieQuickAddKindAttr = function getFoodNoteItemCalorieQuickAddKindAttr(item) {
  var _item$kind = item.kind,
      kind = _item$kind === void 0 ? '' : _item$kind,
      item_name = item.item_name,
      quick_add_type = item.quick_add_type;
  var attrs = FoodNoteItemCalorieOr3NutritionQuickAddKindAttr[quick_add_type];

  if (!!(attrs !== null && attrs !== void 0 && attrs[kind])) {
    return attrs[kind];
  }

  var attr = Object.values(FoodNoteItemCalorieQuickAddKindAttr).find(function (attr) {
    return attr.item_name === item_name;
  });

  if (attr) {
    return attr;
  }

  return FoodNoteItemCalorieQuickAddKindAttr[FoodNoteItemCalorieQuickAddKind.custom];
};